import { Permission as legacyPermission } from '@retailer-platform/dashboard/utils'

export enum Permission {
  InsightsPortalAdsDashboard = 'insights_portal.view_ads_dashboard',
  Performance = 'insights_portal.performance',
  DataExplorer = 'insights_portal.data_explorer',
  ExecutiveSummary = 'insights_portal.executive_summary',
  InsightsPortalCampaign = 'insights_portal_retailer_funded_marketing.insights',
  InsightsPortalCollections = 'insights_portal_retailer_collections.view',
  InsightsPortalCollectionsTemp = 'retailer_collections.view', // TODO remove
  Placements = 'insights_portal.placements',
  InsightsPortalRetailerFundedMarketingAdminAccess = 'insights_portal_retailer_funded_marketing.admin',
  Analytics = 'insights_portal_analytics.legacy_permission',
  PickupAnalytics = 'insights_portal_pickup_analytics.legacy_permission',
}
